import FloatingThemeMenu from "src/components/FloatingThemeMenu";
import usePresentGatheringThemeEdit from "../hooks/usePresentGatheringThemeEdit";

export const GatheringFloatingThemeMenu = ({ show }: { show: boolean }) => {
	const { floatingMenuProps } = usePresentGatheringThemeEdit();
	return <FloatingThemeMenu show={show} {...floatingMenuProps} />;
};
